import React, { useState } from 'react';
import { Row, Button, InlineEditColumnProps, FormInput, InlineEditTable, MasterDetailForm, Widget } from '@digital/ui';
import { TipoPacote, TPData } from '@app/api/tipoPacote';
import { Input, Icon, Collapse } from 'antd';
import { hasPermission } from '@app/helpers/permissions';

interface TipoPacoteProps {
  titulo: string;
  label: string;
  data: TipoPacote[];
  handleDelete(id: string): Promise<unknown>;
  handleCreate: (record: Omit<TPData, 'codigo'>) => Promise<TipoPacote | undefined>;
  handleUpdate: (record: { id: string; nome: string }) => Promise<boolean>;
  shouldUpdate: (needed: boolean) => void;
  isUpdate: boolean;
}

const TipoPacoteComponent = (props: TipoPacoteProps) => {
  const { titulo, label, data, isUpdate, handleCreate, handleUpdate, handleDelete, shouldUpdate } = props;
  const [nome, setNome] = useState<string>('');

  const customColumns = () => {
    return [
      {
        title: 'Codigo',
        dataIndex: 'data.codigo',
        width: '10%',
      },
      {
        title: 'Nome',
        dataIndex: 'data.nome',
        width: '80%',
        renderEdit: () => <FormInput name="data.nome" disabled={false} required />,
      },
      {
        title: 'Opções',
        render: (item: TipoPacote) =>
          hasPermission(['ACRONIMOS_DELETAR']) && (
            <>
              <Button
                confirm="Deseja realmente excluir este registro?"
                okText="Confirmar"
                onClick={() => handleDelete(item.id)}
                icon="science-minus"
              />
            </>
          ),
      },
    ] as InlineEditColumnProps<TipoPacote>[];
  };

  const handleChangeNome = (value: string) => (value.length > 0 ? setNome(value) : setNome(''));

  const handleClick = async () => {
    if (nome) {
      const result = await handleCreate({ nome });
      if (result) {
        
        !isUpdate ? shouldUpdate(true) : shouldUpdate(false);
      }
    }
  };

  const { Panel } = Collapse;

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="1" header={titulo} style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                hasPermission(['ACRONIMOS_SALVAR', 'ACRONIMOS_EDITAR']) && (
                      <Button icon="commons-ok" name="" title="Salvar" onClick={handleClick} />
                ),
              ]}>
              <Row>
                <InlineEditTable
                  rowKey="id"
                  columns={customColumns()}
                  updateItem={hasPermission(['ACRONIMOS_EDITAR']) ? handleUpdate : undefined}
                  dataSource={data}
                  pagination={false}
                  disablenotification={false}
                />
              </Row>
              <Row>
                <fieldset>
                  <legend>Inserir Nova Linha</legend>
                  <FormInput
                    name="nome"
                    label="Nome"
                    placeholder={label}
                    title="Nome"
                    onChange={e => (hasPermission(['ACRONIMOS_EDITAR']) ? handleChangeNome(e.target.value) : undefined)}
                    span={3}
                  />
                </fieldset>
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default TipoPacoteComponent;
